<section class="section" id="apply">
  <!-- Apply form -->
  <div class="apply-wrap" style="margin-top: -19px">
    <div style="text-align: center; margin-bottom: 32px">
      <h2 style="font-size: clamp(28px, 3vw, 44px); margin-top: 12px; line-height: 1.05">
        {{ 'LANDING.APPLY.TITLE' | translate }}
      </h2>
      <p
        style="
          font-size: 16px;
          color: var(--muted);
          margin-top: 12px;
          max-width: 520px;
          margin-left: auto;
          margin-right: auto;
        "
      >
        {{ 'LANDING.APPLY.SUBTITLE' | translate }}
      </p>
    </div>

    @if (success()) {
      <div
        style="
          margin-bottom: 20px;
          padding: 16px 20px;
          border-radius: 14px;
          background: #e6f4ec;
          border: 1px solid #1f9d6a40;
          color: #178654;
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 600;
        "
      >
        <lucide-icon
          [img]="CheckCircle2"
          style="width: 20px; height: 20px; flex-shrink: 0"
        ></lucide-icon>
        {{ 'LANDING.APPLY.SUCCESS' | translate }}
      </div>
    }
    @if (error()) {
      <div
        style="
          margin-bottom: 20px;
          padding: 16px 20px;
          border-radius: 14px;
          background: #fbe5dd;
          border: 1px solid #a8462e40;
          color: #a8462e;
        "
      >
        {{ error() }}
      </div>
    }

    <form (ngSubmit)="submit()">
      <div class="apply-grid">
        <div class="apply-field">
          <label class="apply-label" for="aFullName">{{
            'LANDING.APPLY.LABEL_NAME' | translate
          }}</label>
          <input
            id="aFullName"
            name="fullName"
            [(ngModel)]="form.fullName"
            class="apply-input"
            [placeholder]="'LANDING.APPLY.PLACEHOLDER_NAME' | translate"
          />
        </div>
        <div class="apply-field">
          <label class="apply-label" for="aPhone">{{
            'LANDING.APPLY.LABEL_PHONE' | translate
          }}</label>
          <input
            id="aPhone"
            name="phoneNumber"
            [(ngModel)]="form.phoneNumber"
            class="apply-input"
            placeholder="+998 90 123 45 67"
          />
        </div>
        <div class="apply-field">
          <label class="apply-label" for="aCompany">{{
            'LANDING.APPLY.LABEL_COMPANY' | translate
          }}</label>
          <input
            id="aCompany"
            name="companyName"
            [(ngModel)]="form.companyName"
            class="apply-input"
            [placeholder]="'LANDING.APPLY.PLACEHOLDER_COMPANY' | translate"
          />
        </div>
        <div class="apply-field">
          <label class="apply-label" for="aBizType">{{
            'LANDING.APPLY.LABEL_BIZ_TYPE' | translate
          }}</label>
          <input
            id="aBizType"
            name="businessType"
            [(ngModel)]="form.businessType"
            class="apply-input"
            [placeholder]="'LANDING.APPLY.PLACEHOLDER_BIZ_TYPE' | translate"
          />
        </div>
        <div class="apply-field span-2">
          <label class="apply-label" for="aNotes">{{
            'LANDING.APPLY.LABEL_NOTES' | translate
          }}</label>
          <textarea
            id="aNotes"
            name="notes"
            [(ngModel)]="form.notes"
            class="apply-input"
            rows="4"
            [placeholder]="'LANDING.APPLY.PLACEHOLDER_NOTES' | translate"
            style="resize: none; min-height: 100px"
          ></textarea>
        </div>
      </div>
      <button type="submit" class="apply-submit" [disabled]="submitting()">
        <lucide-icon [img]="Send" style="width: 18px; height: 18px"></lucide-icon>
        {{ (submitting() ? 'LANDING.APPLY.SUBMITTING' : 'LANDING.APPLY.SUBMIT') | translate }}
      </button>
    </form>
  </div>
</section>
